import styles from './BotChannel.module.scss'

interface BotBubbleProps {
  text: string
  position: 'top-left' | 'bottom-left' | 'top-right' | 'bottom-right'
  onCtaClick: (msg: string) => void
}

const BotBubble = ({ text, position, onCtaClick }: BotBubbleProps) => (
  <div className={`${styles.botBubble} ${styles[position]}`} onClick={() => onCtaClick(text)}>
    <p className={styles.bubbleText}>{text}</p>
  </div>
)

export default BotBubble
